import { render, staticRenderFns } from "./delete_proposal_request.vue?vue&type=template&id=d97825ee&"
import script from "./delete_proposal_request.vue?vue&type=script&lang=js&"
export * from "./delete_proposal_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports